import { PluginDefinition } from 'yam-types'
import alertOperator from './handlers/alert'
import loggingOperator from './handlers/logging'
import monitorOperator from './handlers/monitor'
import { name, version } from './package.json'
import * as schema from './schema.json'
import * as settings from './settings.json'
import { AppAlert, AppLogging, AppMonitor } from './types.d'

export default {
  name,
  schema,
  settings,
  version,
  handlers: {
    'observe.monitor': monitorOperator,
    'observe.alert': alertOperator,
    'observe.logging': loggingOperator,
  }
} as PluginDefinition<AppMonitor | AppAlert | AppLogging>